import React from "react";
import classNames from "classnames";
import { DesignContextProvider } from "Components/DesignContext";
import {
   Button,
   Modal,
   ModalBody,
   ModalHeader,
   ModalProps,
} from "Components/ReactstrapSlim";

import classes from "./VerificationPopUp.module.scss";

export interface VerificationPopUpProps extends ModalProps {
   title: string;
   actionText: string;
   icon?: React.ReactElement;
   toggle?: () => void;
}

const VerificationPopUp: React.FC<VerificationPopUpProps> = ({
   toggle,
   title,
   children,
   icon = null,
   actionText,
   className,
   ...props
}) => {
   return (
      <DesignContextProvider name="primary">
         <Modal centered backdrop="static" className={classNames(classes.modal, className)} {...props}>
            <ModalHeader toggle={toggle} />
            <ModalBody className={classes.bodyContainer}>
               {icon && (
                  <div className={classes.icon}>
                     {React.cloneElement(icon)}
                  </div>
               )}
               <h3 className={classes.title}>{title}</h3>
               <span className={classes.description}>{children}</span>
               <Button
                  className={classes.action}
                  size="sm"
                  color="primary"
                  onClick={toggle}
               >
                  {actionText}
               </Button>
            </ModalBody>
         </Modal>
      </DesignContextProvider>
   );
};

export default VerificationPopUp;
